import React, { useState, useEffect } from "react";
import DeleteModalComponent from "../../../Common/DeleteModal";
import ControlWorkProgram from "../../MasterRepository/controlWorkProgram";
import PropTypes from 'prop-types';
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

export default function WorkProgram(props) {
  const { workProgramData, handleDelete, exitEdit } = props;

  const [wpId, setWpId] = useState("");
  const [userId, setUserId] = useState();
  const [wpData, setWpData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editScreen, setEditScreen] = useState(false);
  const [viewScreen, setViewScreen] = useState(false);
  const [workProgramCategory, setWorkProgramCategory] = useState();
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: categoryListAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: selectWorkPrograms } = useHttp();

  useEffect(() => {
    setEditScreen(false);
    setTableData(workProgramData);
    setFilter(workProgramData);
    let totalPageLength = Math.ceil((workProgramData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
    getAllCtrlWPCategory();
  }, [workProgramData, exitEdit]);

  useEffect(() => {
    const result = tableData?.filter((workProgramList) => {
      return workProgramList.work_program_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [search]);

  const handleCancel = () => {
    setModalVisible(false);
  };

  const getByWPRequestID = async (ID, vendorid) => {
    selectWorkPrograms(APIService.selectWorkPrograms(ID, vendorid), (res) => {
      setWpData(res.MSG)
      setEditScreen(true);
    });
  };

  const getAllCtrlWPCategory = async () => {
    await categoryListAPI(APIService.getAllCtrlWPCategoryList(), (data) =>
      setWorkProgramCategory(data.MSG)
    );
  };
  const handelEditScreen = () => {
    setEditScreen(false);
    setTableData(workProgramData);
    setFilter(workProgramData);
    let totalPageLength = Math.ceil((workProgramData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
      setSearch("");
  };

  const getControlWorkProgram = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) =>
        data.MSG.forEach(function (a) {
          a.valid_till = a.valid_till.substring(0, 10);
          a.valid_from = a.valid_from.substring(0, 10);
        })
    );
  };

  const renderActionCell = (row) => {
    return(
      <>
        <span className="Appkit4-icon icon-view-fill  action-icon pointer" title="View request" onClick={() => handleViewButton(row)}></span> &nbsp;
        <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit Role" onClick={() => handleEditButton(row)}></span> &nbsp;
        <span className="Appkit4-icon icon-delete-fill action-icon pointer" title="Delete Role" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.work_program_name).charAt(1);
    const secondOrderId = (b.work_program_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.work_program_name).charAt(1);
  const secondOrderId = (b.work_program_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}

const handleViewButton = (row) => {
  getByWPRequestID(row?.workprogram_id, row?.workprogram_id);
  setViewScreen(true);
}

const handleEditButton = (row) => {
  getByWPRequestID(row?.workprogram_id, row?.workprogram_id);
  setWpId(row?.workprogram_id);
  setViewScreen(false);
}

const handleDeleteButton = (row) => {
  setModalVisible(true);
  setEditScreen(false);
  setWpId(row?.workprogram_id);
  setUserId(sessionStorage.getItem("userId"));
  setSearch("");
}

  return (
    <div className="App">
      {editScreen ? (
        <ControlWorkProgram
          sendBack={handelEditScreen}
          reload={getControlWorkProgram}
          workProgramCategory={workProgramCategory}
          WorkProgramData={wpData}
          workProgramID={wpId}
          viewScreen={viewScreen}
        />
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Work Program Name"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="work_program_name" sortKey={filter.length > 0 ? "work_program_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Work Program Name</Column>
                    <Column field="workprogram_owner" sortKey={filter.length > 0 ? "workprogram_owner" : ""}>Work Program Owner</Column>
                    <Column field="category_name" sortKey={filter.length > 0 ? "category_name" : ""}>Work Program Type</Column>
                    <Column field="valid_from" sortKey={filter.length > 0 ? "valid_from" : ""}>Valid From</Column>
                    <Column field="valid_till" sortKey={filter.length > 0 ? "valid_till" : ""}>Valid To</Column>
                    <Column field="workprogram_id" className="workProgramme"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
          <DeleteModalComponent
            content={
              "Are you sure you want to delete this control work program?"
            }
            visible={modalVisible}
            cancel={handleCancel}
            confirm={() => handleDelete(wpId, userId, sessionStorage.getItem("email"), setModalVisible)}
          />
        </div>
      )}
    </div>
  );
}
WorkProgram.propTypes = {
  workProgramData: PropTypes.array,
  handleDelete: PropTypes.func,
  exitEdit: PropTypes.bool,
}
